import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);
$(document).ready(function () {
    function sectionAnimateCircle(section) {

        let mm = gsap.matchMedia();
        mm.add("(max-width: 767.5px)", () => {

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $(section),
                    start: "10% 94px",
                    end: "+=4500 center",
                    scrub: true,
                    pin: true,
                    pinSpacer: false,
                    //markers: true,
                }
            });

            const sectionTextItem = gsap.utils.toArray($(section).find('.fade-in-item-js'));

            const duration = 6;

            sectionTextItem.forEach((text, i) => {

                if (i === sectionTextItem.length - 1) {
                    tl.to(text, {
                            yPercent: -100,
                            duration: duration,

                        },
                    )
                        .to($(section).find('#Group-3 path'), {opacity: 0.4}, '<+=5%')
                        .to($(section).find('#Path-6,#Path-9'), {opacity: 1,}, '<+=10%')

                    tl.to({}, {
                        duration: duration / 2,
                    });

                } else if (i === 0) {
                    tl.to(text, {
                            yPercent: -156,
                            delay: 3,
                            duration: duration,
                        }
                    )
                        .to($(section).find('#Group-3 path'), {opacity: 1})

                } else {
                    tl.to(text, {
                        yPercent: -100,
                        duration: duration,

                    })
                        .to($(section).find('#Group-3 path'), {opacity: 0.4}, '<+=5%')
                    let targetSvg;

                    switch (i) {
                        case 1:
                            targetSvg = $(section).find('#Path-10, #Path-11,#Path-13')
                            break;
                        case 2:
                            targetSvg = $(section).find('#Path-5,#Path-15,#Path-14')
                            break;
                        case 3:
                            targetSvg = $(section).find('#Path-12')
                            break;
                        case 4:
                            targetSvg = $(section).find('#Path-1,#Path-0,#Path-3')
                            break;

                    }
                    tl.to(targetSvg, {opacity: 1,}, '<+=10%')

                    tl.to(text, {
                        yPercent: -156,
                        delay: duration + 4,
                        duration: duration,
                    })

                }
            })


        });
    }

    sectionAnimateCircle('.section-kompetenzen-animation');

    function sectionAnimateCircleDesktop(section) {
        const $section = $(section);
        const $fadeItems = $section.find('.fade-in-item-js');
        const $group3Path = $section.find('#Group-3 path');

        if ($(window).width() >= 768) {
            $fadeItems.attr('style', '')
            $fadeItems.hover(function () {
                const i = $(this).data('hover');
                const targetSvg = getTargetSvg(i);
                gsap.to($group3Path, {opacity: 0.4});
                gsap.to(targetSvg, {opacity: 1});
            }, function () {
                gsap.to($group3Path, {opacity: 1});
            });
        } else {
            $fadeItems.off("click");
        }
    }

    function getTargetSvg(i) {
        const $section = $('.section-kompetenzen-animation');
        switch (i) {
            case 0:
                return $section.find('#Group-3 path');
            case 1:
                return $section.find('#Path-10, #Path-11, #Path-13');
            case 2:
                return $section.find('#Path-5, #Path-15, #Path-14');
            case 3:
                return $section.find('#Path-12');
            case 4:
                return $section.find('#Path-1, #Path-0, #Path-3');
            case 5:
                return $section.find('#Path-6, #Path-9');
            default:
                return $();
        }
    }


    const multiple = 40;
    const $mouseOverContainer = $(".section-kompetenzen-animation");
    const $element = $mouseOverContainer.find('#Group');

    function transformElement(x, y, minCalc, maxCalc) {
        const box = $element[0].getBoundingClientRect();
        const calcX = clamp((y - box.y - (box.height / 2)) / multiple, minCalc, maxCalc);
        const calcY = clamp((x - box.x - (box.width / 2)) / multiple, minCalc, maxCalc);
        $element.css('transform', `translateX(${calcY}px) translateY(${calcX}px)`);
    }

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function handleMouseEnter(e) {
        window.requestAnimationFrame(function () {
            transformElement(e.clientX, e.clientY, -12, 12);
        });
    }

    function handleMouseLeave() {
        window.requestAnimationFrame(function () {
            $element.css('transform', "translateX(0) translateY(0)");
        });
    }

    function updateEventListeners() {
        if (window.innerWidth >= 768) {
            $mouseOverContainer.on('mousemove', handleMouseEnter);
            $mouseOverContainer.on('mouseleave', handleMouseLeave);
        } else {
            $mouseOverContainer.off('mousemove', handleMouseEnter);
            $mouseOverContainer.off('mouseleave', handleMouseLeave);
        }
    }

    updateEventListeners();
    sectionAnimateCircleDesktop('.section-kompetenzen-animation');


    $(window).resize(function () {
        sectionAnimateCircleDesktop('.section-kompetenzen-animation');
        updateEventListeners();
    });
})

